import styled from 'styled-components';
import { ActiveFilters } from '../../../components/ModelInstanceFilter';
import { useFilterGroupContext } from './FilterGroupContext';

const FilterGroupNav: React.FC = () => {
  const {
    orderedChildFilters,
    activeChildKey,
    setActiveChildKey,
    draftSelections,
  } = useFilterGroupContext();

  return (
    <NavList>
      {orderedChildFilters.map(([childKey, child]) => (
        <NavItem
          key={childKey}
          $active={childKey === activeChildKey}
          onClick={() => setActiveChildKey(childKey)}
        >
          <span>{child.name}</span>
          {(draftSelections[childKey]?.length || 0) > 0 && (
            <ActiveFilters>
              <span>{draftSelections[childKey].length}</span>
            </ActiveFilters>
          )}
        </NavItem>
      ))}
    </NavList>
  );
};

export default FilterGroupNav;

const NavList = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 140px;
  border-right: 1px solid rgba(0, 0, 0, 0.06);
  padding-right: ${({ theme }) => theme.spacing.sm};
  margin-right: ${({ theme }) => theme.spacing.sm};
`;

const NavItem = styled.div<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.xs};
  padding: 6px 8px;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  cursor: pointer;
  font-size: 12px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  background: ${({ $active }) =>
    $active ? 'rgba(0, 0, 0, 0.04)' : 'transparent'};

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
`;
